import classNames from "classnames";
import React, { PureComponent } from "react";

import { ITestable, testAttr } from "@/browser";

import { groupTextClass, IStyleMargin, IStyleSize, IStyleTextColor, IStyleWeight, marginClass } from "../Style";

type Style = IStyleSize & IStyleTextColor & IStyleWeight & IStyleMargin;

export interface IIconProps extends Partial<Style>, ITestable {
  /** Code of a icon - see code example below */
  icon: string;

  /**
   * Extend component classes
   * @default undefined
   */
  className?: string;

  /**
   * Position of icon - left or right
   * @default undefined
   */
  position?: "left" | "right";

  /**
   * Square classes for icon
   * @default undefined
   */
  square?: boolean;

  /**
   * Display icon as cover
   * @default undefined
   */
  cover?: boolean;

  /**
   * Disabled icon
   * @default false
   */
  disabled?: boolean;
}

/**
 * This component is for display Icon passing icon code, size etc.
 */
export class Icon extends PureComponent<IIconProps> {
  render() {
    const { icon, color, className, disabled, size, position, square, cover, weight, margin } = this.props;
    const classes = classNames(
      groupTextClass({ weight, color }),
      marginClass(margin),
      "el-icon",
      {
        [`el-icon--${icon}`]: !!icon,
        [`el-icon--size-${size}`]: !!size,
        [`el-icon--position-${position}`]: !!position,
        "el-icon--disabled": !!disabled,
        "el-icon--square": !!square,
        "el-icon--cover": cover,
      },
      className,
    );
    const testableProps = testAttr(this.props, { sufix: "icon" });

    return <i className={classes} {...testableProps} />;
  }
}

export default Icon;
